import { useLocation } from 'react-router-dom'

const useUrlSegments = (): string[] => {
  const location = useLocation()
  const path = location.pathname
  const segments = path.split('/').filter(Boolean)
  return segments
}

export default useUrlSegments
